import { HttpClient } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { Observable, catchError, map, of } from 'rxjs'

import { ApiClass } from '@data/class/api-class'
import { environment } from '@env/environment'
import { DocumentationThread, ThreadCounts, ThreadStatus } from '../../interfaces/documentation.interface'

@Injectable({ providedIn: 'root' })
export class DocumentationService extends ApiClass {
  private readonly httpClient = inject(HttpClient)

  constructor() {
    super()
    this.path = 'documentation'
  }

  /** El HTML del manual es un asset del propio bundle, no viene de la API. */
  getContent(assetPath: string): Observable<string> {
    return this.httpClient.get(assetPath, { responseType: 'text' }).pipe(catchError(() => of('')))
  }

  getThreads(docSlug: string): Observable<any> {
    return this.getCollections({ docSlug }, environment.apiUrl, 'documentation/threads')
  }

  getCounts(docSlugs: string[]): Observable<Record<string, ThreadCounts>> {
    return this.getCollections({ docSlugs: docSlugs.join(',') }, environment.apiUrl, 'documentation/threads/counts').pipe(map((res) => res.data ?? {}))
  }

  createThread(payload: { docSlug: string; blockId: string; anchorText: string; content: string }): Observable<any> {
    return this.postCollection(payload, 'threads')
  }

  addComment(threadId: string, content: string): Observable<any> {
    return this.postCollection({ content }, `threads/${threadId}/comments`)
  }

  setStatus(threadId: string, status: ThreadStatus): Observable<any> {
    return this.patchCollection({ status }, environment.apiUrl, `documentation/threads/${threadId}/status`)
  }

  updateComment(commentId: string, content: string): Observable<any> {
    return this.patchCollection({ content }, environment.apiUrl, `documentation/comments/${commentId}`)
  }

  deleteComment(commentId: string): Observable<any> {
    return this.deleteCollection(commentId, environment.apiUrl, 'documentation/comments')
  }
}

/** El backend devuelve el hilo completo tras cada escritura: así la UI nunca reconstruye a mano. */
export const asThread = (data: any): DocumentationThread | null => (data && data._id ? (data as DocumentationThread) : null)
